import { useEffect, useState } from "react"
import { CardTitle, Col, Form, FormFeedback, Input } from "reactstrap"

//Lightbox
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";

import * as Yup from "yup";
import { useFormik } from "formik";

import Spinners from "Components/Common/Spinner";
import { useDocumentFindAllQuery, useSafetyUpdateMutation } from "store";
import DocumentsUpload from "Components/fileUpload/DocumentsUpload";
import { Link } from "react-router-dom";
import Flatpickr from "react-flatpickr";
import { numberWithCommas } from "../../helpers/globalHelper";



const Detail = (props: any) => {
  const [safetyOne, setSafetyOne] = useState<any>(null);
  const [photoIndex, setphotoIndex] = useState<number>(0);
  const [isGalleryZoom, setisGalleryZoom] = useState<boolean>(false);
  const [isLoading, setLoading] = useState(true)
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [isEdited, setIsEdited] = useState<boolean>(false);

  const [documentList, setDocumentList] = useState<any>([]);
  const [imageZoom, setImageZoom] = useState<any>([]);

  const [safetyUpdate, safetyUpdateResult] = useSafetyUpdateMutation();

  const {
    data: documentFiles,
    error: documentFilesError,
    isFetching: isDocumentFilesFetching,
  } = useDocumentFindAllQuery(`?table_name=safety&connection_id=${props?.data?.id}`);

  useEffect(() => {
    if (props?.data === null) {
      setSafetyOne(null)
      setLoading(true)
    } else {
      setLoading(false)
      setSafetyOne(props?.data)
    }
    console.log(props);

    setDocumentList(documentFiles?.data)
    documentList?.forEach((item) => {
      if (item?.type_name === 'image') {
        setImageZoom(item.fileUrl);
      }
    });

    const imageUrls = documentList
      ?.filter((item) => item?.type_name === 'image')
      ?.map((item) => item.fileUrl);

    setImageZoom(imageUrls || []);


  }, [props?.data, props?.table_name, props?.id, safetyOne, documentList, documentFiles])

  const validation: any = useFormik({
    enableReinitialize: true,
    initialValues: {
      funder_description: safetyOne?.funder_description,
      company_description: safetyOne?.company_description,
      description: safetyOne?.description,
      total_cost: safetyOne?.total_cost,
      safeted_date: safetyOne?.safeted_date,
    },
    validationSchema: Yup.object({
      funder_description: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      description: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      company_description: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      total_cost: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      safeted_date: Yup.date().typeError("Он сар өдөр оруулна уу").required("Утга оруулна уу !"),
    }),
    onSubmit: (values: any) => {
      if (isEdited && isEdit) {
        const updateSafetyList = {
          id: safetyOne ? safetyOne.id : 0,
          table_name: props?.table_name,
          connection_id: props?.id,
          funder_description: values.funder_description,
          company_description: values.company_description,
          description: values.description,
          total_cost: values.total_cost,
          safeted_date: values.safeted_date,
        };
        console.log('ain');

        safetyUpdate(updateSafetyList)
      }
      // else {
      //   const newStaffList = {
      //     funder_description: values["funder_description"],
      //     company_description: values["company_description"],
      //     description: values["description"],
      //     total_cost: values["total_cost"],
      //     safeted_date: values["safeted_date"],
      //   };
      // }
      // validation.resetForm();
      // toggle();
    },
  });

  return (
    <>
      {isLoading ? (
        <Spinners setLoading={setLoading} />
      ) : (
        <>
          <Col xl={4}>
            <h5 className="fw-semibold text-center">Санхүүжүүлэлт</h5>
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                setIsEdited(true);
                return false;
              }}
            >
              <div className="table-responsive">
                <table className="table">
                  <tbody>
                    <tr>
                      <th scope="col">Санхүүжүүлэгч:</th>
                      <td className="fs-6">
                        <Input
                          name="funder_description"
                          type="text"
                          disabled={!isEdit}
                          validate={{
                            required: { value: true },
                          }}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.funder_description || ""}
                          invalid={
                            validation.touched.lname && validation.errors.funder_description ? true : false
                          }
                        />
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Хамгаалсан/нөхөн сэргээлт хийсэн байгууллага:</th>
                      <td className="fs-6">
                        <Input
                          name="company_description"
                          type="text"
                          disabled={!isEdit}
                          validate={{
                            required: { value: true },
                          }}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.company_description || ""}
                          invalid={
                            validation.touched.lname && validation.errors.company_description ? true : false
                          }
                        />
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Тайлбар</th>
                      <td className="fs-6">
                        <Input
                          name="description"
                          type="text"
                          disabled={!isEdit}
                          validate={{
                            required: { value: true },
                          }}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.description || ""}
                          invalid={
                            validation.touched.lname && validation.errors.description ? true : false
                          }
                        />
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Зарцуулсан хөрөнгийн хэмжээ, мян.төг</th>
                      <td>
                        <Input
                          name="total_cost"
                          type="text"
                          disabled={!isEdit}
                          validate={{
                            required: { value: true },
                          }}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={numberWithCommas(validation.values.total_cost) || ""}
                          invalid={
                            validation.touched.lname && validation.errors.total_cost ? true : false
                          }
                        />
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Хамгаалах арга хэмжээ авсан огноо</th>
                      <td>
                        <Flatpickr
                          className="form-control d-block"
                          placeholder="Огноо"
                          name="safeted_date"
                          disabled={!isEdit}
                          value={validation.values.safeted_date}
                          onChange={(selectDate: Date[]) => {
                            if (selectDate[0]) {
                              const localDate = new Date(selectDate[0].getTime() - selectDate[0].getTimezoneOffset() * 60000)
                                .toISOString()
                                .split('T')[0];
                              validation.setFieldValue('safeted_date', localDate);
                            }
                          }}
                          options={{
                            altInput: true,
                            altFormat: "Y-m-d",
                            dateFormat: "Y-m-d",
                            enableTime: false,
                          }}
                        />
                        {validation.touched.registred_date &&
                          validation.errors.registred_date ? (
                          <FormFeedback type="invalid">
                            {validation.errors.registred_date}
                          </FormFeedback>
                        ) : null}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="hstack gap-2">
                <button type="button" className={`btn btn-${!isEdit ? 'warning' : 'success'} w-100`} onClick={() => { setIsEdit(!isEdit); if (isEdited && !isEdit) validation.resetForm(); }}> {!!isEdit ? "Харах" : "Засах"}   </button>
                <button type="submit" className="btn btn-primary w-100" > Засварлах </button>
              </div>
            </Form>
          </Col>
          <Col lg={5}>
            <CardTitle>Холбогдох зурагнууд</CardTitle>
            <div className="zoom-gallery d-flex gap-3 flex-row flex-wrap justify-content-center">
              {imageZoom.map((img, index) => (
                <img
                  key={index}
                  src={img}
                  className="float-left"
                  onClick={() => {
                    setisGalleryZoom(true);
                    setphotoIndex(index);
                  }}
                  width="275"
                />
              ))}
            </div>
            {isGalleryZoom && (
              <Lightbox
                mainSrc={imageZoom[photoIndex]}
                nextSrc={imageZoom[(photoIndex + 1) % imageZoom.length]}
                prevSrc={imageZoom[(photoIndex + imageZoom.length - 1) % imageZoom.length]}
                onCloseRequest={() => setisGalleryZoom(false)}
                onMovePrevRequest={() => setphotoIndex((photoIndex + imageZoom.length - 1) % imageZoom.length)}
                onMoveNextRequest={() => setphotoIndex((photoIndex + 1) % imageZoom.length)}
              />
            )}
            <CardTitle className="mt-3">Холбогдох PDF файлууд</CardTitle>
            <div className="mb-3">
              {
                documentList
                  ?.filter((item) => item?.type_name === "pdf")
                  ?.map((item, index) => (
                    <Link
                      key={index}
                      to={item?.fileUrl}
                      target="__blank"
                      className="btn btn-danger me-2 btn-label"
                    >
                      <i className="mdi mdi-file-pdf-outline label-icon"></i>
                      Файл-{index + 1}
                    </Link>
                  ))
              }
            </div>

            <CardTitle className="mt-3">Холбогдох WORD файлууд</CardTitle>
            <div className="mb-3">
              {
                documentList
                  ?.filter((item) => item?.type_name === "word")
                  ?.map((item, index) => (
                    <Link
                      key={index}
                      to={item?.fileUrl}
                      target="__blank"
                      className="btn btn-success me-2 btn-label"
                    >
                      <i className="mdi mdi-microsoft-excel label-icon"></i>
                      Файл-{index + 1}
                    </Link>
                  ))
              }
            </div>

            {safetyOne?.id === null && undefined ? '' :
              <DocumentsUpload
                table_name={'safety'}
                connection_id={safetyOne?.id}
                value_group={'base'}
              />
            }


          </Col>
        </>
      )}
    </>
  );


}

export default Detail;